<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><p>①.スマートフォンからSafari / Chrome / Firefoxにて「study.adsol-asia.jp」にアクセスします。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\pwa_1.png" alt="" /></div>
                <div><p>②.各ブラウザの「ホーム画面に追加」機能にてスマートフォンのホーム画面にアプリの「アイコン」を追加します。</p></div>
                <div><p>■ Safari</p></div>
                <div><p>・画面下部のツールバーの中央にある「追加・共有・保存」アイコンをクリックし、サブメニューが表示されます。</p></div>
                <div><p>・「ホーム画面に追加」メニューをクリックすると、「StudyArts」のアプリアイコンがホーム画面に追加されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\pwa_2_1.png" alt="" /></div>
                <div><p>■ Chrome</p></div>
                <div><p>・「︙」アイコンをクリックすると、画面の右側からメニューが表示されます。</p></div>
                <div><p>・「ホーム画面に追加」メニューをクリックすると、「ホーム画面に追加」ポップアップ画面が表示されます。</p></div>
                <div><p>・「ホーム画面に追加」のポップアップ画面で【追加】ボタンを押すと、以下のようなポップアップ画面に遷移します。</p></div>
                <div><p>・「自動追加」ボタンを押すと、スマートフォンのホーム画面に「StudyArts」のアプリアイコンが追加されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\pwa_2_2.png" alt="" /></div>
                <div><p>■ Firefox</p></div>
                <div><p>・「︙」アイコンをクリックすると、画面の右側からメニューが表示されます。</p></div>
                <div><p>・「インストール」メニューをクリックすると、ホーム画面に「StudyArts」のアプリアイコンが追加されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\pwa_2_3.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>①.スマートフォンからSafari / Chrome / Firefoxにて「study.adsol-asia.jp」にアクセスします。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\pwa_1.png" alt="" /></div>
                <div><p>②.各ブラウザの「ホーム画面に追加」機能にてスマートフォンのホーム画面にアプリの「アイコン」を追加します。</p></div>
                <div><p>■ Safari</p></div>
                <div><p>・画面下部のツールバーの中央にある「追加・共有・保存」アイコンをクリックし、サブメニューが表示されます。</p></div>
                <div><p>・「ホーム画面に追加」アイコンをクリックすると、「StudyArts」のアプリアイコンがホーム画面に追加されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\pwa_2_1.png" alt="" /></div>
                <div><p>■ Chrome</p></div>
                <div><p>・「︙」アイコンをクリックすると、画面の右側からメニューが表示されます。</p></div>
                <div><p>・「ホーム画面に追加」メニューをクリックすると、「ホーム画面に追加」ポップアップ画面が表示されます。</p></div>
                <div><p>・「ホーム画面に追加」のポップアップ画面で【追加】ボタンを押すと、以下のようなポップアップ画面に遷移します。</p></div>
                <div><p>・「自動追加」ボタンを押すと、スマートフォンのホーム画面に「StudyArts」のアプリアイコンが追加されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\pwa_2_2.png" alt="" /></div>
                <div><p>■ Firefox</p></div>
                <div><p>・「︙」アイコンをクリックすると、画面の右側からメニューが表示されます。</p></div>
                <div><p>・「インストール」メニューをクリックすると、ホーム画面に「StudyArts」のアプリアイコンが追加されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\pwa_2_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/pwa_manual.vue